import { ChatbotAttachmentProvider } from 'features/chatbot'
import { DocumentAgentProvider } from 'features/knowledgeDocumentViewer/contexts/DocumentAgentContext'
import { KnowledgeDocumentDataProvider } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentDataContext'
import { KnowledgeDocumentUXProvider } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentUXContext'
import { PipelineConfigProvider } from 'features/knowledgeDocumentViewer/contexts/PipelineConfigContext'
import { TimeSeriesLinkProvider } from 'features/knowledgeDocumentViewer/contexts/TimeSeriesLinkContext'
import { useGeckoPermissions } from 'features/permissions'
import { useMemo } from 'react'
import { DocumentViewerUrlPaths } from 'routes/documents/-searchParams'
import {
  PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_ADMIN,
  PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_EDITOR,
  ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_EDITOR,
} from 'types'

import { KnowledgeDocumentTools } from './components/KnowledgeDocumentTools'

export type KnowledgeDocumentViewerProps = {
  siteID: string
  organizationID: string
  viewOnly?: boolean
  basePath: DocumentViewerUrlPaths
}

export function KnowledgeDocumentViewer({
  siteID,
  organizationID,
  viewOnly = true,
  basePath,
}: KnowledgeDocumentViewerProps) {
  const { hasPermissions } = useGeckoPermissions()
  const isEditor = hasPermissions([
    PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_EDITOR,
    PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_ADMIN,
    ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_EDITOR,
  ])

  const forceViewOnly = useMemo(() => {
    return !isEditor ? true : viewOnly
  }, [isEditor, viewOnly])

  return (
    <ChatbotAttachmentProvider>
      <PipelineConfigProvider siteID={siteID}>
        <KnowledgeDocumentUXProvider
          basePath={basePath}
          viewOnly={forceViewOnly}
          siteId={siteID}>
          <KnowledgeDocumentDataProvider siteID={siteID} orgID={organizationID}>
            <DocumentAgentProvider>
              <TimeSeriesLinkProvider siteID={siteID}>
                <KnowledgeDocumentTools scale={2} />
              </TimeSeriesLinkProvider>
            </DocumentAgentProvider>
          </KnowledgeDocumentDataProvider>
        </KnowledgeDocumentUXProvider>
      </PipelineConfigProvider>
    </ChatbotAttachmentProvider>
  )
}
